<script lang="ts">
  /**
   * The problems the engine found, listed under the editor that has them.
   *
   * The editor underlines the same ranges, but an underline cannot say what is
   * wrong, and a problem with nothing to underline, like a parse error at the
   * end of the input, would otherwise have nothing to show at all.
   */
  import type { EditorDiagnostic } from '../lib/diagnostics';

  interface Props {
    diagnostics: EditorDiagnostic[];
    /** The source the offsets are into, for counting lines. */
    source: string;
  }

  let { diagnostics, source }: Props = $props();

  /** A one-based line number for a source offset. */
  function lineOf(offset: number): number {
    return source.slice(0, Math.max(offset, 0)).split('\n').length;
  }
</script>

{#if diagnostics.length > 0}
  <ul class="diagnostics">
    {#each diagnostics as entry, index (index)}
      <li>
        <span class="line">line {lineOf(entry.start)}</span>
        <span>{entry.message}</span>
      </li>
    {/each}
  </ul>
{/if}

<style>
  .diagnostics {
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    display: grid;
    gap: 4px;
  }

  .diagnostics li {
    display: flex;
    gap: 10px;
    font-size: 13px;
    color: var(--text-dim);
    background: var(--bg-raised);
    border-left: 3px solid var(--fail);
    border-radius: 4px;
    padding: 5px 10px;
  }

  .diagnostics .line {
    font-family: var(--mono);
    font-size: 12px;
    color: var(--text-faint);
    flex: none;
  }
</style>
